import { Component } from "react";
import Api from "entities/helpers/api";
import PropTypes from "prop-types";
import WithSession from "base/session/with-session";
import _ from "underscore";
import moment from "moment";

import EverTrue from "app";

class TodoDataContainer extends Component {
  static propTypes = {
    gte: PropTypes.number,
    lte: PropTypes.number,
    render: PropTypes.func,
    session: PropTypes.object,
    onlyIncomplete: PropTypes.bool,
  };

  static defaultProps = {
    gte: 0,
    lte: 0,
    render: () => {},
    session: {},
    onlyIncomplete: false,
  };

  state = {
    todos: [],
    loading: false,
  };

  componentDidMount() {
    this.fetchTodos();
  }

  componentDidUpdate(prevProps) {
    if (this.props.gte !== prevProps.gte || this.props.lte !== prevProps.lte) {
      this.fetchTodos();
    }
  }

  fetchTodos = () => {
    const user_id = this.props.session.user.id;
    const date_from = this.props.gte;
    const date_to = this.props.lte;

    let filter_params = {
      assignee_user_id: user_id,
      due_date_gte: date_from,
      due_date_lte: date_to,
    };
    if (this.props.onlyIncomplete) {
      filter_params.completed = false;
    }
    this.setState({ loading: true });
    Api.UGC.TODOS.post({
      urlExtend: `/filter`,
      params: {
        limit: 100,
        offset: 0,
      },
      data: _.jsonStringify(filter_params),
    })
      .then(todos_res => {
        this.setState({
          todos: todos_res,

          loading: false,
        });
      })
      .catch(err => {
        this.setState({ loading: false });
      });
  };

  markTodoComplete = todo => {
    EverTrue.track.set("todo_action", { type: "todo_complete" });
    Api.UGC.TODOS.put({
      urlExtend: `/${todo.id}`,
      data: _.jsonStringify({
        completed: !todo.completed,
      }),
    }).then(() => {
      if (todo.completed) {
        this.alertWithMessage(todo.summary + " " + moment(todo.due_date).format("MMM DD") + " marked incomplete");
      } else {
        this.alertWithMessage(todo.summary + " " + moment(todo.due_date).format("MMM DD") + " marked complete");
      }
      this.fetchTodos();
    });
  };

  deleteToDo = id => {
    EverTrue.track.set("todo_action", { type: "todo_delete" });
    Api.UGC.TODOS.delete({
      urlExtend: `/${id}`,
    }).then(() => {
      this.fetchTodos();
      this.alertWithMessage("Todo Successfully Deleted");
    });
  };

  createTodo = todo => {
    EverTrue.track.set("todo_action", { type: "todo_create" });
    const new_todo = { ...todo, completed: false };
    return Api.UGC.TODOS.post({
      data: _.jsonStringify(new_todo),
    }).then(result_todo => {
      this.fetchTodos();
      return result_todo;
    });
  };

  editToDo = todo => {
    EverTrue.track.set("todo_action", { type: "todo_edit" });
    const assignee_user_id = todo.assignee_user_id ? todo.assignee_user_id : todo.id;
    return Api.UGC.TODOS.put({
      urlExtend: `/${todo.id}`,
      data: _.jsonStringify({
        completed: todo.completed,
        due_date: todo.due_date,
        summary: todo.summary,
        description: todo.description,
        assignee_user_id: assignee_user_id,
      }),
    }).then(result_todo => {
      this.fetchTodos();
      return result_todo;
    });
  };

  alertWithMessage = msg => {
    EverTrue.Alert.success(<div>{msg}</div>);
  };

  render() {
    const todos = this.state.todos;

    return this.props.render({
      todos,
      refresh: this.fetchTodos,
      deleteTodo: this.deleteToDo,
      editTodo: this.editToDo,
      markComplete: this.markTodoComplete,
      createTodo: this.createTodo,
      loading: this.state.loading,
    });
  }
}

export default WithSession(TodoDataContainer);
